// export const KEY = '/v1/balance';
export var ITEMS_PER_PAGE = 10;
export var ROW_TYPES = {
    SEARCH: 'Consulta',
    MONITOR: 'Monitoria',
    // PAUSE: 'Pausa',
};
